import flatMap from "lodash/flatMap";
import isEmpty from "lodash/isEmpty";
import map from "lodash/map";
import get from "lodash/get";

export const getTransformedData = (data) => {
  let keyCounter = 0;

  const tableData = flatMap(get(data, "shifts"), (shift) => {
    const shiftComponents = get(shift, "components");
    const time_range = `${get(shift, "shift_start", "--")} - ${get(
      shift,
      "shift_end",
      "--",
    )}`;
    if (isEmpty(shiftComponents)) {
      return [
        {
          key: keyCounter++,
          shift_name: get(shift, "name"),
          operator: get(shift, "operator"),
          supervisor: get(shift, "supervisor"),
          customer: "--",
          component: "--",
          planned_cycle_time: "--",
          avg_cycle_time: "--",
          product_efficiency: "--",
          machine_efficiency: "--",
          time_range: time_range || "--",
          part_name: "--",
          cavity: get(shift, "shift_meta.cavity"),
          oee: get(shift, "shift_meta.oee"),
          shots: get(shift, "shift_meta.total_shots", 0),
          counts: get(shift, "shift_meta.total_counts", 0),
          count: get(shift, "shift_meta.total_count", 0),
          target_count: get(shift, "shift_meta.target_count", 0),
          rejected_count: get(shift, "shift_meta.total_rejected_count", 0),
          net_count: get(shift, "shift_meta.net_count", 0),
          length: get(shift, "shift_meta.total_length", 0),
          total_power_consumption: get(
            shift,
            "shift_meta.total_power_consumption",
            0,
          ),
          planned_cycle_time: get(shift, "shift_meta.planned_cycle_time", 0),
          avg_cycle_time: get(shift, "shift_meta.avg_cycle_time", 0),
          product_efficiency: get(shift, "shift_meta.product_efficiency", 0),
          machine_efficiency: get(shift, "shift_meta.machine_efficiency", 0),
          total_working_hours: get(shift, "shift_meta.total_working_hours", 0),
          total_idle_hours: get(shift, "shift_meta.total_idle_hours", 0),
          total_off_hours: get(shift, "shift_meta.total_off_hours", 0),
          machining_cycle: 0,
          press_cycle: 1,
          shot_weight: get(shift, "shift_meta.shot_weight", null),
          part_weight: get(shift, "shift_meta.part_weight", null),
          total_raw_weight: get(shift, "shift_meta.total_raw_weight", null),
          total_finished_weight: get(
            shift,
            "shift_meta.total_finished_weight",
            null,
          ),
        },
      ];
    }
    return flatMap(shiftComponents, (component) => {
      const componentParts = get(component, "parts");
      const time_range = `${get(component, "start_time", "--")} - ${get(
        component,
        "end_time",
        "--",
      )}`;
      return map(componentParts, (part) => ({
        key: keyCounter++,
        shift_name: get(shift, "name", "--"),
        operator: get(shift, "operator", "--"),
        supervisor: get(shift, "supervisor", "--"),
        customer: get(component, "customer")
          ? get(component, "customer")
          : "--",
        component: get(component, "name", "--"),
        planned_cycle_time: get(
          component,
          "component_meta.planned_cycle_time",
          0,
        ),
        avg_cycle_time: get(component, "component_meta.avg_cycle_time", 0),
        product_efficiency: get(
          component,
          "component_meta.product_efficiency",
          0,
        ),
        machine_efficiency: get(
          component,
          "component_meta.machine_efficiency",
          0,
        ),
        time_range: time_range || "--",
        part_name: get(part, "name"),
        cavity: get(part, "cavity"),
        oee: get(part, "oee"),
        shots: get(part, "shots", 0),
        counts: get(part, "counts", 0),
        count: get(part, "count", 0),
        press_cycle: get(part, "press_cycle", 1),
        target_count: get(part, "target_count", 0),
        rejected_count: get(part, "rejected_count", 0),
        length: get(part, "length", 0),
        net_count: get(part, "net_count", 0),
        total_power_consumption: get(component, "total_power_consumption", 0),
        total_working_hours: get(component, "total_working_hours", 0),
        total_idle_hours: get(component, "total_idle_hours", 0),
        total_off_hours: get(component, "total_off_hours", 0),
        rejected_scrap: get(part, "rejected_scrap_type.name"),
        shot_weight: get(part, "shot_weight", null),
        part_weight: get(part, "part_weight", null),
        total_raw_weight: get(part, "raw_weight", null),
        total_finished_weight: get(part, "finished_weight", null),
        machining_cycle: get(part, "machining_cycle", null),
        oee: get(part, "part_meta.oee"),
      }));
    });
  });

  const totals = {
    ...get(data, "template_meta"),
  };

  return { tableData, totals };
};
